export const LANGUAGES = {
  ENGLISH: 'en',
  FRENCH: 'fr',
  GERMAN: 'de',
  JAPANESE: 'ja',
  ESPANIOL: 'es',
  CHINESE: 'zh',
};
